import type { User } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/user/models';
import { apiIns } from 'src/config/apiClient';

import { createAppAsyncThunk } from '../model';

// Thunk for getting user profile
export const getMyProfile = createAppAsyncThunk<User, void>('auth/getMyProfile', async (_, { rejectWithValue }) => {
  try {
    const profile: User = await apiIns.user.me();
    return profile;
  } catch (error) {
    localStorage.clear();
    return rejectWithValue(error);
  }
});
